import {
  useApiMutation,
  getFinancialDocumentTaskStatus,
  createFinancialDocumentDownloadTask,
  useApiPolling,
} from '@hum/api';
import {
  CompanyFileDocumentType,
  FinancialDocumentTaskStates,
  ConnectorType,
  ConnectorSource,
} from '@hum/types';

export const useDownloadFinancialDocuments = ({
  companyId,
  connectorType,
  docType,
  connectorSource,
}: {
  companyId: string;
  docType: CompanyFileDocumentType;
  connectorType?: ConnectorType;
  connectorSource?: ConnectorSource;
}) => {
  const { mutate: downloadFinancialDocuments } = useApiMutation(
    createFinancialDocumentDownloadTask,
    {
      onSuccess(data) {
        if (data?.taskId) {
          startPolling({
            companyId: companyId,
            taskId: data?.taskId || '',
            docType: docType,
            connectorType: connectorType,
            connectorSource: connectorSource,
          });
        }
      },
    }
  );

  const {
    data: task,
    isPolling,
    startPolling,
    stopPolling,
    isError,
  } = useApiPolling(getFinancialDocumentTaskStatus, {
    onPollSuccess(data) {
      if (!data) return;

      const isTerminalState = [
        FinancialDocumentTaskStates.Failure,
        FinancialDocumentTaskStates.Success,
      ].includes(data.state);

      if (isTerminalState || isError) {
        stopPolling();

        if (
          data.state === FinancialDocumentTaskStates.Success &&
          data.fileUrl
        ) {
          window.location.assign(data.fileUrl);
        }
      }
    },
  });

  return {
    task,
    isPolling,
    isError,
    stopDownload: stopPolling,
    handleDownloadFinancialDocuments: () =>
      downloadFinancialDocuments({
        companyId,
        docType,
        connectorType,
        connectorSource,
      }),
  };
};
